module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/ph-pic-hover-867268.svg";